import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f075442"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-x4 text-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-x4 text-center"
}
const _hoisted_3 = {
  key: 0,
  class: "mt-x2"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-x2 flex"
}
const _hoisted_5 = {
  key: 0,
  class: "mx-x2"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "o-text-h4 mb-x4 text-center" }
const _hoisted_8 = { key: 1 }

import {
    CustomerDeliveryCheckOutDeliverable,
    DeliveryType,
    EarliestCustomerDeliveryDates,
} from '@/b2c/shared/api/server-apis';
import CheckoutDeliveryOption from '@/b2c/checkout/ui/CheckoutDeliveryOption.vue';
import CheckoutPickUpOption from '@/b2c/checkout/ui/CheckoutPickUpOption.vue';
import CheckoutDeliverableItems from '@/b2c/checkout/ui/items/CheckoutDeliverableItems.vue';
import { useCheckout } from '@/b2c/checkout/useCheckout';
import CheckoutDeliverableGoToNext from '@/b2c/checkout/ui/CheckoutDeliverableGoToNext.vue';
import { computed, ref, watch } from 'vue';
import SplitDeliveryDialog from '@/b2c/checkout/ui/splitdelivery/SplitDeliveryDialog.vue';
import useBooleanToggle from '@/shared/useBooleanToggle';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';
import CheckoutCustomerDeliverableSkeleton from '@/b2c/checkout/ui/deliverables/CheckoutCustomerDeliverableSkeleton.vue';
import { useStepReset } from '@/b2c/checkout/useStepReset';
import CheckoutSkeletonLine from '@/b2c/shared/checkout/ui/CheckoutSkeletonLine.vue';
import WebApiMessage from '@/core/http/WebApiMessage.vue';
import CheckoutRadioButton from '@/shared/checkout/ui/CheckoutRadioButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutCustomerDeliverable',
  props: {
    deliverable: null,
    index: null
  },
  setup(__props: any) {

const props = __props as {
    deliverable: CustomerDeliveryCheckOutDeliverable;
    index: number
}



const labels = useBlockLabels();
const { setDeliveryInformationForItems, clearDeliveryInformationForItems, removeSplitDelivery, removeSplitDeliveries, deliveryInfo, updateStep, getPickUpErrorMessageId } = useCheckout();
const { isToggled, toggle } = useBooleanToggle();
const resetStep = useStepReset();
const pendingUndoAllSplits = ref<boolean>(false);

const deliverableHasBeenSplitOrJoinedIdentifier = computed<number>(() => props.deliverable.itemIds.length);
watch(deliverableHasBeenSplitOrJoinedIdentifier, () => {
    setDeliveryInformationForItems(props.deliverable.id);
}, { immediate: true });

const updateStepAndRemoveSplitDelivery = (id: number) :void => {
    updateStep(1);
    removeSplitDelivery(id);
};

const undoAllSplits = async(): Promise<void> => {
    resetStep();
    clearDeliveryInformationForItems(props.deliverable.id);
    pendingUndoAllSplits.value = true;
    await removeSplitDeliveries(props.deliverable.id).finally(() => pendingUndoAllSplits.value = false);
};

const relatedDeliveryInfo = computed<EarliestCustomerDeliveryDates | undefined>(() => {
    return deliveryInfo.value[props.deliverable.id];
});

const shouldDisableDeliveryOptions = computed(() => {
    return (!relatedDeliveryInfo?.value?.canBeDelivered && relatedDeliveryInfo?.value?.shouldBeSplit) ? true : null;
});

const deliveryType = computed(() => {
    if (shouldDisableDeliveryOptions.value) {
        return '';
    } else if (props.deliverable.deliveryType) {
        return props.deliverable.deliveryType;
    }

    return DeliveryType.Shipping;
});

const selectedDeliveryType = ref<DeliveryType | string>('');

watch(relatedDeliveryInfo, () => {
    selectedDeliveryType.value = deliveryType.value;
}, { immediate: true });

const isClientPickUpValid = ref<boolean>(false);
const handleIsClientPickUpValid = (isValid) => {
    isClientPickUpValid.value = isValid;
};

const isClientValid = computed<boolean>(() => {
    const isSameDeliveryTypeAsServerState = props.deliverable.deliveryType === selectedDeliveryType.value;
    const isPickUpSelectedDeliveryType = selectedDeliveryType.value === DeliveryType.PickUp;
    const isValid = isPickUpSelectedDeliveryType ? isClientPickUpValid.value : isSameDeliveryTypeAsServerState;
    return isValid;
});

const shippingIsSelected = computed(() => selectedDeliveryType.value === DeliveryType.Shipping);
const pickUpIsSelected = computed(() => selectedDeliveryType.value === DeliveryType.PickUp);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", null, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$dictionary.pluralize(__props.deliverable.itemIds.length, _unref(labels).customerDeliveryDescription, _unref(labels).customerDeliveryDescriptionPlural)), 1),
      (_unref(relatedDeliveryInfo)?.canRemoveSplit)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_unref(labels).splitDeliverySplitDescription) + " ", 1),
            _createElementVNode("button", {
              class: "c-magic-line c-magic-line--underline",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {updateStepAndRemoveSplitDelivery(props.deliverable.id);}, ["prevent"]))
            }, _toDisplayString(_unref(labels).splitDeliverySplitCancel), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.deliverable.id)
        ? (_openBlock(), _createBlock(CheckoutDeliverableItems, {
            key: 1,
            deliverable: __props.deliverable
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (!_unref(relatedDeliveryInfo))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(CheckoutSkeletonLine, {
                        dark: true,
                        class: "mb-8"
                      }),
                      _createVNode(CheckoutSkeletonLine, {
                        dark: true,
                        class: "mb-8"
                      }),
                      _createVNode(CheckoutSkeletonLine, {
                        dark: true,
                        class: "mx-auto sm:w-1/3"
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(relatedDeliveryInfo)?.generalLabel)
                        ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
                            key: 0,
                            label: _unref(relatedDeliveryInfo).generalLabel,
                            class: "mt-x4"
                          }, null, 8, ["label"]))
                        : _createCommentVNode("", true),
                      _createVNode(_Transition, {
                        name: "o-anim-fade-300",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("div", {
                            key: _unref(relatedDeliveryInfo)?.canUndoSplit,
                            class: "flex justify-center"
                          }, [
                            (_unref(relatedDeliveryInfo)?.canBeSplit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                  _createElementVNode("button", {
                                    class: "c-magic-line c-magic-line--underline",
                                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(toggle) && _unref(toggle)(...args)), ["prevent"]))
                                  }, _toDisplayString(_unref(relatedDeliveryInfo)?.canUndoSplit ? _unref(labels).splitDeliveryDoSplitFurtherLink : _unref(labels).splitDeliveryDoSplitLink), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_unref(relatedDeliveryInfo)?.canUndoSplit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                  (_unref(relatedDeliveryInfo)?.canBeSplit)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(labels).splitDeliverySplitLinkDelimiter), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["c-magic-line c-magic-line--underline", { 'c-magic-line--disabled': pendingUndoAllSplits.value}]),
                                    onClick: _withModifiers(undoAllSplits, ["prevent"])
                                  }, _toDisplayString(_unref(labels).splitDeliveryUndoSplitLink), 11, _hoisted_6)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        ]),
                        _: 1
                      })
                    ], 64)),
                _createVNode(SplitDeliveryDialog, {
                  deliverable: __props.deliverable,
                  "is-open": _unref(isToggled),
                  onClose: _unref(toggle)
                }, null, 8, ["deliverable", "is-open", "onClose"])
              ])
            ]),
            _: 1
          }, 8, ["deliverable"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass({'disabled-styling': _unref(shouldDisableDeliveryOptions)})
      }, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$dictionary.pluralize(__props.deliverable.itemIds.length, _unref(labels).customerDeliverySelectionHeading, _unref(labels).customerDeliverySelectionHeadingPlural)), 1),
        (!_unref(relatedDeliveryInfo))
          ? (_openBlock(), _createBlock(CheckoutCustomerDeliverableSkeleton, {
              key: 0,
              "pickup-disabled": __props.deliverable.isPickupDisabled
            }, null, 8, ["pickup-disabled"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(CheckoutRadioButton, {
                modelValue: selectedDeliveryType.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDeliveryType).value = $event)),
                disabled: _unref(shouldDisableDeliveryOptions),
                value: _unref(DeliveryType).Shipping,
                label: _unref(labels).customerDeliverySelectShipping,
                "is-selected": _unref(shippingIsSelected),
                name: "deliveryOption"
              }, {
                default: _withCtx(() => [
                  (_unref(shippingIsSelected))
                    ? (_openBlock(), _createBlock(CheckoutDeliveryOption, {
                        key: _unref(deliverableHasBeenSplitOrJoinedIdentifier),
                        class: "mt-x1",
                        deliverable: __props.deliverable
                      }, null, 8, ["deliverable"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "value", "label", "is-selected"]),
              _withDirectives(_createVNode(CheckoutRadioButton, {
                modelValue: selectedDeliveryType.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedDeliveryType).value = $event)),
                disabled: _unref(shouldDisableDeliveryOptions),
                value: _unref(DeliveryType).PickUp,
                label: _unref(labels).customerDeliverySelectPickUp,
                "is-selected": _unref(pickUpIsSelected),
                name: "deliveryOption"
              }, {
                default: _withCtx(() => [
                  (_unref(pickUpIsSelected))
                    ? (_openBlock(), _createBlock(CheckoutPickUpOption, {
                        key: _unref(deliverableHasBeenSplitOrJoinedIdentifier),
                        class: "mt-x1 mx-30",
                        deliverable: __props.deliverable,
                        onClientValidityChange: handleIsClientPickUpValid
                      }, null, 8, ["deliverable"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue", "disabled", "value", "label", "is-selected"]), [
                [_vShow, !__props.deliverable.isPickupDisabled]
              ]),
              _createVNode(WebApiMessage, {
                id: _unref(getPickUpErrorMessageId)(__props.deliverable.id),
                "clear-timing": 100000000,
                class: "ml-25"
              }, null, 8, ["id"])
            ]))
      ], 2)
    ]),
    _createVNode(CheckoutDeliverableGoToNext, {
      index: __props.index,
      deliverable: __props.deliverable,
      "is-client-valid": _unref(isClientValid)
    }, null, 8, ["index", "deliverable", "is-client-valid"])
  ]))
}
}

})